import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import { createStructuredSelector } from "reselect";
import LottiePlayer from "components/LottiePlayer";
import { colorify } from "lottie-colorify";
import { RenderInvestmentStatus } from "components/InvestmentStatusModal";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import { KYC_STATUS_LOCAL } from "constants/status";
import { tenantPrimaryColors } from "constants/index";
import { fetchDashboardDetailsStart } from "store/user/dashboard/actions";
import { setInvestmentStepData, clearInvestmentStepData } from "store/user/investment/actions";
import { selectInvestmentSuccessData } from "store/user/investment/selectors";
import { selectUserDashboardDetails } from "store/user/account/selectors";
import { setAdequacyStart } from "store/user/adequacy/actions";
import { selectPlatformSourceFromApp, selectTenant } from "store/app/selectors";
import animatedFlowerIcon from "./FlowerIcon.json";
import { selectCurrenKYCStatus } from "store/user/kyc/selectors";

const messages = {
    heading: "congratulation",
    subheading: "submitted_your_investment",
    kycInitiatedOrPending: "kyc_initiated_pending",
    kycInitiated: "reject_your_investment_offer",
    kycPending: "your_investment_offer_released",
    kycSuccess: "investment_offer_being_checked",
    buttonText: "back_to_product_page",
    backToDashboard: "back_to_dashboard",
};

const InvestmentSuccess = ({
    className = "",
    setInvestmentStepData,
    clearInvestmentStepData,
    fetchDashboardDetailsStart,
    investmentSuccessData = {},
    hideInvestmentModal,
    setInvestmentKycModalFlag,
    setAdequacyStartStep,
    openInvestment,
    isApp,
    backSlideEffect = "",
    currentTenant,
    currentKYCStatus,
}) => {
    useSideModalScrollToTop();

    const router = useRouter();
    const { formatMessage } = useFormattedMessage();

    useEffect(() => {
        fetchDashboardDetailsStart();
        setInvestmentStepData({
            investSum: {
                digitalShares: null,
                sum: null,
                projectID: null,
                ID: null,
            },
        });
    }, []);

    return (
        <div className={`${className} invest-success investment-success-screen text-center ${backSlideEffect}`}>
            <LottiePlayer
                autoplay
                loop={false}
                keepLastFrame
                speed={1}
                src={colorify(
                    [
                        undefined,
                        tenantPrimaryColors[currentTenant]?.primaryDark,
                        undefined,
                        tenantPrimaryColors[currentTenant]?.primary,
                        undefined,
                        tenantPrimaryColors[currentTenant]?.secondaryColor,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        tenantPrimaryColors[currentTenant]?.primaryLight,
                        undefined,
                        tenantPrimaryColors[currentTenant]?.secondaryLight,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                    ],
                    animatedFlowerIcon,
                )}
                style={{ maxWidth: 180, marginBottom: 30, marginTop: 30 }}
            />
            <p className="mb-10 font-weight-600">{formatMessage(messages.heading)}</p>
            <p className="mb-10">{formatMessage(messages.subheading)}</p>
            {(currentKYCStatus === KYC_STATUS_LOCAL.INITIATED || currentKYCStatus === KYC_STATUS_LOCAL.PENDING) && (
                <p className="mb-10 font-weight-600">{formatMessage(messages.kycInitiatedOrPending)}</p>
            )}
            {currentKYCStatus === KYC_STATUS_LOCAL.INITIATED && (
                <p className="mb-10 font-weight-600">{formatMessage(messages.kycInitiated)}</p>
            )}
            {currentKYCStatus === KYC_STATUS_LOCAL.PENDING && (
                <p className="mb-10 font-weight-600">{formatMessage(messages.kycPending)}</p>
            )}
            {currentKYCStatus === KYC_STATUS_LOCAL.COMPLETED && (
                <p className="mb-10 font-weight-600">{formatMessage(messages.kycSuccess)}</p>
            )}
            <RenderInvestmentStatus
                setInvestmentKycModalFlag={setInvestmentKycModalFlag}
                hideInvestmentModal={hideInvestmentModal}
                investmentData={investmentSuccessData}
                currentKYCStatus={currentKYCStatus}
                clearInvestmentStepData={clearInvestmentStepData}
                setAdequacyStartStep={setAdequacyStartStep}
            />
            <div className="border-x" />
            <button
                className="mw-10 mb-0"
                onClick={() => {
                    clearInvestmentStepData && clearInvestmentStepData();
                    setAdequacyStartStep && setAdequacyStartStep({ step: 1 });
                    isApp && openInvestment && router.push("/dashboard", undefined, { shallow: true });
                }}
            >
                {isApp && openInvestment ? formatMessage(messages.backToDashboard) : formatMessage(messages.buttonText)}
            </button>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    userDashboardData: selectUserDashboardDetails,
    investmentSuccessData: selectInvestmentSuccessData,
    isApp: selectPlatformSourceFromApp,
    currentTenant: selectTenant,
    currentKYCStatus: selectCurrenKYCStatus,
});

const mapDispatchToProps = (dispatch) => ({
    setAdequacyStartStep: (data) => dispatch(setAdequacyStart(data)),
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    clearInvestmentStepData: () => dispatch(clearInvestmentStepData()),
    fetchDashboardDetailsStart: () => dispatch(fetchDashboardDetailsStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentSuccess);
